import React, { Component } from 'react';
import { Button, DatePicker, message, Modal, Row, Col, Typography, InputNumber, Popconfirm } from 'antd';
import CpProductInfo from '../../components/CpProductInfo';
import CpLoading from '../../components/CpLoading';
import send from '../../util/request';
import { statusIndexToText, statusToButtons } from './statusConfig';
import moment from 'moment';
import { dateFormat, amountToString, formatAddressList, downLoad } from '../../util/tool';
import RenderPopover from '../../components/RenderPopover';
import RenderNumberPopover from './component/RenderNumberPopover';
import { getAddressList } from '../apis/address';
import { planOrderCreate, planOrderReceive } from './api';
import './style.less';
import DetailModal from './component/DetailModal';

const orderSteps = ['提交订单', '待发货', '待收货', '已完成'];
const confirmedSteps = ['提交订单', '待确认', '待发货', '待收货', '已完成'];
const cancelOrderSteps = ['提交订单', '待发货', '已取消'];
// const TransportationType = ['无', '陆运', '海运', '空运', '陆铁联运'];
// const handling_opinion_type_config = ['', '龙头处理', '运到SVC大仓', '其他', '正常进行下阶段'];
const CURRENCY = {
  'CNY': '中国-CNY-￥',
  'USD': '美国-USD-$'
};
const orderStepStatus = {
  "提交订单": 1,
  "待发货": 0,
  "待收货": 0,
  "已完成": 0,
  "已取消": 0
}; // '订单状态：10-已创建；20-待发货；30-已发货|待收货；40-已完成；50-已取消'

function disabledDate(current) {
  return current && current < moment().subtract(1, "days"); //当天之前的不可选，不包括当天
}

class PlanOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      stepCurrent: 1,
      orderInfo: {},
      saleList: [],
      newArriveTime: '',
      loading: true,
      addressList: [],//地址列表
      address_id: undefined,
      detailVisible: false,//费用明细弹窗
      otherCost: 0,//费用
    };
    this.columns = [
      { key: 'product', name: '商品', align: 'left', colSpan: 2, width: 166 },
      { key: 'unit_amount', name: '单价', align: 'center', width: 110 },
      { key: 'number', name: '采购数量', align: 'center', width: 110 },
      { key: 'offer_price', name: '报价单价', align: 'center', width: 110 },
      { key: 'offer_number', name: '报价数量', align: 'center', width: 110 },
      { key: 'tax_rate', name: '税率', align: 'center', width: 110 },
      { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'center', width: 110 },
      { key: 'receive_base_number', name: '收货数量', align: 'center', width: 110 },
      { key: 'subtotal', name: '金额', align: 'center', width: 112 },
      // { key: 'total', name: '总计', align: 'center', width: '' },
    ];

    // this.port_quality_report_columns = [
    //   {
    //     title: '质检单号',
    //     dataIndex: 'quality_no',
    //     key: 'quality_no',
    //     width: 200
    //   },
    //   {
    //     title: '柜号',
    //     dataIndex: 'container_no',
    //     key: 'container_no',
    //     width: 100,
    //     render: (text, record) => {
    //       const { base = {} } = record;
    //       const { container_no = '' } = base;
    //       return container_no;
    //     }
    //   },
    //   {
    //     title: '提交时间',
    //     dataIndex: 'commit_time',
    //     key: 'commit_time',
    //     width: 200,
    //   },
    //   {
    //     title: '卖方处理状态',
    //     dataIndex: 'status',
    //     key: 'status',
    //     width: 100,
    //     render: (text, record) => {
    //       return +text === 2 ? '未处理' : (+text === 3 ? '已处理' : '-');
    //     }
    //   },
    //   {
    //     title: '卖方处理意见',
    //     dataIndex: 'handling_opinion_desc',
    //     key: 'handling_opinion_desc',
    //     width: 200,
    //     render: (text, record) => {
    //       const { handling_opinion_desc, handling_opinion_type } = record;
    //       return <>
    //         <div>{handling_opinion_type_config[handling_opinion_type]}</div>
    //         <Tooltip title={handling_opinion_desc}>
    //           <div className='self-ellipsis'>{handling_opinion_desc}</div>
    //         </Tooltip>
    //       </>;
    //     }
    //   },
    //   {
    //     title: '操作',
    //     dataIndex: 'operate',
    //     key: 'operate',
    //     width: 100,
    //     render: (text, record) => {
    //       return <>
    //         <Typography.Link onClick={() => this.goPortQualityReport(record)}>查看</Typography.Link>
    //       </>;
    //     }
    //   },
    // ];
    // this.warehouse_quality_report_columns = [
    //   {
    //     title: '质检单号',
    //     dataIndex: 'quality_no',
    //     key: 'quality_no',
    //     width: 200
    //   },
    //   {
    //     title: '柜号',
    //     dataIndex: 'container_no',
    //     key: 'container_no',
    //     width: 100
    //   },
    //   {
    //     title: '提交时间',
    //     dataIndex: 'update_time',
    //     key: 'update_time',
    //     width: 200,
    //     render: (text, record) => {
    //       const { status } = record; //1-草稿 2-已提交 3-已处理
    //       return <>{+status === 1 ? '-' : text}</>;
    //     }
    //   },
    //   {
    //     title: '卖方处理状态',
    //     dataIndex: 'status',
    //     key: 'status',
    //     width: 100,
    //     render: (text, record) => {
    //       //1-草稿 2-已提交 3-已处理
    //       const status_opinion = {
    //         1: '-',
    //         2: '未处理',
    //         3: '已处理'
    //       };
    //       return status_opinion[+text];
    //     }
    //   },
    //   {
    //     title: '卖方处理意见',
    //     dataIndex: 'sale_comments',
    //     key: 'sale_comments',
    //     width: 200,
    //     render: (text, record) => {
    //       const { handling_opinions } = record;
    //       return +handling_opinions === 0 && !text ? '-' :
    //         <>
    //           <div>{handling_opinion[+handling_opinions]}</div>
    //           {
    //             text ? <Tooltip title={text}>
    //               <div className='self-ellipsis'>{text}</div>
    //             </Tooltip> : '-'
    //           }
    //         </>;
    //     }
    //   },
    //   {
    //     title: '操作',
    //     dataIndex: 'operate',
    //     key: 'operate',
    //     width: 100,
    //     render: (text, record) => {
    //       const { status } = record; //1-草稿 2-已提交 3-已处理
    //       return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    //         {<Typography.Link onClick={() => this.goWarehouseQualityReport(record)}>{+status === 1 ? '编辑' : '查看'}</Typography.Link>}
    //         {<Typography.Link onClick={() => this.commitWarehouseQualityReport(record)}>{+status === 1 ? '提交' : ''}</Typography.Link>}
    //       </div>;
    //     }
    //   },
    // ];
    this.orderId = this.props.match.params.id;
  }

  componentDidMount() {
    this.requestOrderInfo(this.orderId);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestAddressList = async () => {
    const { data: { data, code, msg } } = await getAddressList();
    if (+code === 0) {
      const { list } = data;
      const { address_id } = this.state;
      const addressList = formatAddressList(list);
      const hasCurrentAddress = addressList.filter(item => String(item.id) !== String(address_id));
      this.setState({ addressList: hasCurrentAddress });
    } else {
      message.error(msg);
    }
  }
  requestOrderInfo = (orderId) => {
    send({
      url: '/ipp/plan-order/info',
      method: 'POST',
      data: { order_no: orderId }
    }).then(res => {
      const { data: { data = {}, code, msg = '' } } = res;
      if (+code === 0) {
        const { tax_inclusive_real_price, create_time, order_no, id, supplier_name, real_price, expected_date, order_desc, order_status, settle_order_no,
          purchase_id, purchase_name, supplier_id, delivery_type, productInfo = [], syncInfo, supplierInfo, abroad_transport_type, domestic_transport_type,
          consignee_name, consignee_mobile, province_name, city_name, district_name, address, address_id, order_source: orderSource, parentInfo = {},
          port_quality_report = [], is_report, warehouse_quality_report = [], order_source = '', order_source_desc = '', qualifications = [], costInfo, currency, warehouse = {} } = data;
        const saleList = productInfo.map(item => ({ ...item, supplier_id, mapping: JSON.parse(item.mapping || '{}'), receive_base_number: order_status === 5 ? item.sale_number * item.base_factor : item.receive_base_number }));
        const statusText = statusIndexToText['' + order_status], arriveTime = expected_date;
        const orderInfo = {
          ...data,
          tax_inclusive_real_price,
          createTime: create_time,
          orderNo: order_no,
          orderId: id,
          supplier: supplier_name,
          realPrice: real_price,
          orderStatus: +order_status,
          statusText,
          buttonText: statusToButtons['' + order_status],
          purchaseId: purchase_id, // 客户ID
          supplierId: supplier_id, //  商户ID
          orderDesc: order_desc,
          settleOrderNo: settle_order_no,
          purchaseName: purchase_name,
          deliveryType: delivery_type,//物流方式 3tms
          arriveTime,
          totalPrice: real_price,
          userName: consignee_name,
          userPhone: consignee_mobile,
          address: province_name + city_name + district_name + address,
          address_id,
          parentInfo,
          orderSource,
          supplierInfo,
          syncInfo,
          abroad_transport_type,
          domestic_transport_type,
          port_quality_report,
          warehouse_quality_report,
          is_report,
          order_source,
          order_source_desc,
          qualifications,
          currency,
          warehouse,
        };
        const orderStatus = Object.assign({}, orderStepStatus);
        const finallySteps = +order_status === 15 ? confirmedSteps : (+order_status === 50 ? cancelOrderSteps : orderSteps);
        const stepCurrent = finallySteps.findIndex(item => item === statusText);
        for (let i = 0; i <= stepCurrent; i++) {
          orderStatus[finallySteps[i]] = 2;
        }
        const steps = finallySteps.map(item => ({ name: item, status: orderStatus[item] })) || [];
        let total = 0;
        if (costInfo.length > 0) {
          costInfo.forEach(item => {
            if (item.cost_mode === 1) {
              total += +(item.cost_amount);
            } else {
              total += +(item.cost_amount) * tax_inclusive_real_price * 0.01;
            }
          });
        }
        this.setState({
          steps,
          stepCurrent,
          orderInfo,
          loading: false,
          newArriveTime: arriveTime,
          address_id,
          otherCost: total,
          costInfo,
          saleList,
        }, () => {
          this.requestAddressList();
        });
      } else {
        message.error(msg);
      }
    });
  }

  goPortQualityReport = (record) => {
    const { id } = record;
    this.props.history.push('/basic/user/order/portQualityReport/' + id);
  }

  goWarehouseQualityReport = (record) => {
    const { status, quality_no } = record; //1-草稿 2-已提交 3-已处理
    this.props.history.push(`/basic/user/order/warehouseQualityReport/${this.orderId}/${status}/${quality_no}`);
  }

  // commitWarehouseQualityReport = async (record) => {
  //   const { data: { code, msg } } = await createQuality({ ...record, status: 2 });
  //   if (+code === 0) {
  //     message.success('提交成功', () => this.requestOrderInfo(this.orderId));
  //   } else {
  //     message.error(msg);
  //   }
  // }
  createWarehouseQualityReport = () => {
    this.props.history.push(`/basic/user/order/warehouseQualityReport/${this.orderId}/1/0`);
  }

  changeTime = () => {
    this.setState({
      showDatePicker: true
    });
  }

  dateChanged = (moment, date) => {
    let { arriveTime } = this.state.orderInfo;
    this.setState({
      showDatePicker: false
    });

    if (date === arriveTime) { return; }

    let today = dateFormat(new Date(), 'yyyy-MM-dd');
    if (new Date(date).getTime() < new Date(today).getTime()) {
      message.info('期望到货时间不能小于当前时间');
      this.setState({
        newArriveTime: arriveTime
      });
      return;
    }

    send({
      url: '/ipp/plan-order/update',
      method: 'POST',
      data: {
        order_no: this.orderId,
        hope_arrive_time: date
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('期望到货时间修改成功');
        this.setState({
          newArriveTime: date
        });
      } else {
        message.error(res.data.msg);
        this.setState({
          newArriveTime: arriveTime
        });
      }
    });
  }

  btnClicked = () => {
    const { orderInfo } = this.state;
    const status = orderInfo.orderStatus === 30 ? 40 : 50;
    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: this.orderId,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(orderInfo.buttonText + '成功');
        this.requestOrderInfo(this.orderId);
      } else {
        message.error(res.data.msg);
      }
    });
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  }

  handleOk = () => {
    const { orderInfo } = this.state;
    // let status = orderInfo.buttonText === '确认收货' ? 2 : 3;
    const status = orderInfo.orderStatus === 30 ? 40 : 50;

    this.setState({ modalVisible: false });

    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: this.orderId,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(orderInfo.buttonText + '成功');
        this.requestOrderInfo(this.orderId);
      } else {
        message.error(res.data.msg);
      }
    });
  }

  toProductDetail = (product) => {
    const { supplierId } = this.state.orderInfo;
    const { norms_id, sale_id } = product;
    if (!norms_id || !supplierId || !sale_id) {
      message.info('商品缺少spu_id或sale_id或supplier_id');
      return;
    }
    this.props.history.push('/basic/product/detail/' + sale_id + '/' + supplierId + '/' + norms_id);
  }

  renderOrderSourceInfo = (info = {}) => {
    const { orderSource, parentInfo = {} } = info;
    const { operate_name = '' } = parentInfo;
    const orderSourceInfo = [operate_name, 'ERP下单', '统采转单', '供应商分配'];
    return orderSourceInfo[orderSource - 1] || '';
  }

  renderSyncStatus = status => {
    return ['未同步', '已完成', '失败']?.[+status] || '-';
  }
  erpOrderPurchase = async sync_id => {
    const { data: { code, msg } } = await send({ url: '/ipp/order-purchase/send ', method: 'POST', data: { id: sync_id } });
    if (+code === 0) {
      message.success(msg, .5, this.requestOrderInfo(this.orderId));
    } else {
      message.error(msg);
    }
  }
  renderDetail = (info) => {
    if (!info) return;
    const parseInfo = JSON.parse((info));
    const surcharge_desc = !info ? [] : parseInfo;
    const record = { qoute: { surcharge_desc } };
    return <RenderPopover record={record} />;
  }
  renderNumberPopover = (info = {}) => <RenderNumberPopover info={[info]} />;

  downLoadFile = ({ file_name: name, file_url: url }) => downLoad({ url, name });
  createPlanOrder = async () => {
    const { orderInfo: { orderNo: order_no } } = this.state;
    const a = await planOrderCreate({ order_no });
    const { data: { code, msg, data = {} } } = a;
    if (+code === 0) {
      const { order_no } = data;
      message.success('下单成功', 2, () => this.props.history.push(`/basic/user/order/detail/${order_no}/0`));
    } else {
      message.error(msg);
    }
  }
  showDetail = () => {
    this.setState({ detailVisible: true });
  }
  detailCancel = () => {
    this.setState({ detailVisible: false });
  }
  onOpenChange = () => {//关闭时间弹窗
    this.setState({
      showDatePicker: false
    });
  }
  onBlurReceiveNumber = (e, item) => {
    this.setState(prevState => {
      const updatedSaleList = prevState.saleList?.map((saleItem) => (saleItem.id === item.id ? { ...saleItem, receive_base_number: e } : saleItem));
      return { saleList: updatedSaleList };
    });
  }
  confirm = async () => {
    const { saleList } = this.state;
    const receive_data = saleList.map(item => ({ id: item.id, receive_base_number: item.receive_base_number, }));
    const { data: { code } } = await planOrderReceive({ order_no: this.orderId, receive_data });
    if (+code === 0) {
      message.success('收货成功', .5, () => window.location.reload());
    }
  }
  render() {
    const { orderInfo = {}, showDatePicker, loading, newArriveTime, detailVisible, otherCost, costInfo, saleList = [] } = this.state;
    const { tax_inclusive_real_price, currency, postposition_cost, order_status } = orderInfo;
    let totalPrice = +otherCost + (+tax_inclusive_real_price);
    const postposition_cost_condition = postposition_cost === 1;
    const columns = this.columns.filter(item => [20, 40].includes(+orderInfo.orderStatus) ? true : !['offer_number', 'offer_price'].includes(item.key)).filter(item => !postposition_cost_condition ? (item.key !== 'receive_base_number') : true);
    return (
      <div className="plan-order-detail">
        {/* <div className='mb-20'>
          <Link to={{ pathname: '/basic/user/planOrder' }}>我的计划单</Link>
          <RightOutlined />
          <span>订单号：{orderInfo.orderNo}</span>
        </div> */}
        {loading ? <CpLoading size="large" className="cp-loading" /> : null}
        <div className="order-process">
          <div className="order-process-content">
            <div className="order-process-content-item">
              <div>计划单号：{orderInfo.orderNo}</div>
              <div>状态:<Button type='link'> {statusIndexToText[+orderInfo.orderStatus]}</Button></div>
            </div>
            {
              +orderInfo.orderStatus === 40 ? <div className="order-process-content-item">
                {/* <div>采购单号：{orderInfo.orderDesc}</div> */}
                <div><Typography.Link style={{ padding: 0 }} onClick={() => this.props.history.push(`/basic/user/order/detail/${(orderInfo?.orderDesc || orderInfo?.settleOrderNo)}/0`)}>采购单号：{orderInfo?.orderDesc || orderInfo?.settleOrderNo}</Typography.Link></div>
              </div> : null
            }
          </div>
        </div>
        {/* <div className="order-process">
          <div className="order-status">
            <div className="order-no">订单号：{orderInfo.orderNo}</div>
            <div className="order-no">订单来源：{this.renderOrderSourceInfo(orderInfo)}</div>
            <div className="order-no">订单来源：{orderInfo.orderSource}</div>
            <div className="order-no order-transportation-type">
              <span>国内运输方式：{TransportationType[+domestic_transport_type]}</span>
              <span>国际运输方式：{TransportationType[+abroad_transport_type]}</span>
            </div>
            <div className='order-status-operate'>
              <div className="order-status-text">{orderInfo.statusText}</div>
              {orderInfo.buttonText && orderInfo.buttonText.length && (
                <Popconfirm title={`确定${orderInfo.buttonText}?`} onConfirm={this.btnClicked}>
                  <Button className="order-buttons" onClick={this.btnClicked}>{orderInfo.buttonText}</Button>
                  <Button className="order-buttons">{orderInfo.buttonText}</Button>
                </Popconfirm>
              )}
            </div>
          </div>
          <div className="order-steps">
            <div className='order-steps-status'>订单状态</div>
            <CpSteps current={stepCurrent} steps={steps} />
          </div>
        </div> */}
        {/* <div><Logistics orderNo={this.orderId} addressList={addressList} orderInfo={orderInfo}></Logistics></div> */}
        <div className="order-detail-info">
          <div className="left">
            <div className="item mb-20"><span>创建时间：</span>{orderInfo.createTime}</div>
            <div className="item mb-20"><span>供应商：</span>{orderInfo.supplier}</div>
            {
              +orderInfo.orderStatus !== 10 ?
                <div className="item mb-20"><span>期望到货时间：</span>{orderInfo.arriveTime}</div>
                :
                <div className="item mb-20">
                  <span>期望到货时间：</span>
                  <DatePicker
                    bordered={false}
                    allowClear={false}
                    placeholder=""
                    suffixIcon={false}
                    open={showDatePicker}
                    defaultValue={moment(orderInfo.arriveTime)}
                    value={moment(newArriveTime)}
                    disabledDate={disabledDate}
                    onChange={this.dateChanged}
                    onOpenChange={this.onOpenChange}
                  />
                  <a style={{ color: '#007AFF' }} onClick={() => { this.changeTime(); }}>修改</a>
                </div>
            }
            <div className='item'><span style={{ color: '#D60505' }}>结算币种：</span>{+orderInfo.orderStatus === 10 ? <span style={{ color: '#D60505' }}>等待报价</span> : <span style={{ color: '#D60505' }}>{CURRENCY[currency]}</span>}</div>
          </div>
          <div className="right">
            <div className="item mb-20"><span>收货人：</span>{orderInfo.userName}</div>
            <div className="item mb-20"><span>收货地址：</span>{orderInfo.address}</div>
            <div className="item mb-20"><span>收货仓库：</span>{orderInfo.warehouse?.warehouse_name}</div>
            <div className="item mb-20"><span>手机号：</span>{orderInfo.userPhone}</div>
            <div className="item"><span>备注：</span>{orderInfo.orderDesc}</div>
          </div>
        </div>
        <div className="order-product-list">
          {postposition_cost_condition && (orderInfo.orderStatus === 5) && <div style={{ textAlign: 'right', padding: 20 }}>
            <Popconfirm title="确认确认收货？" onConfirm={this.confirm}><Button type='primary'>确认收货</Button></Popconfirm>
          </div>}
          <table className="cp-table" style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                {
                  columns.map((item, index) => {
                    return (<th key={index} style={{ textAlign: item.align, textIndent: index === 0 ? '20px' : '', width: item.width }}>{item.name}</th>);
                  })
                }
              </tr>
            </thead>
            <tbody>
              {
                saleList.map((item, index) => {
                  return (
                    <tr key={index}>
                      {
                        columns.map((col, index) => {
                          if (col.key === 'product') {
                            return (
                              <td key={index} style={{ maxWidth: '150px' }}>
                                <div className="p-info">
                                  <CpProductInfo product={item} toProductDetail={() => { this.toProductDetail(item); }} />
                                </div>
                              </td>
                            );
                          } else if (col.key === 'number') {
                            return (
                              <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                <div>{+item.sale_number}{item.sale_unit}</div>
                                {(item.base_factor > 1) && <div >{+(item.sale_number * item.base_factor).toFixed(3)}{item.base_unit}</div>}
                                {/* <div>{this.renderNumberPopover(item)}</div> */}
                              </td>
                              // <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>x{+item.sale_number}</td>
                            );
                          } else if ((col.key === 'unit_amount')) {
                            //  ￥{amountToString(item.sale_price)}
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600', width: 100 }}>
                              <div>{amountToString(item.sale_price)} / {item.sale_unit}</div>
                              {(item.base_factor > 1) && <div >{amountToString(item.base_price)} / {item.base_unit}</div>}
                            </td>);
                          } else if (col.key === 'tax_rate') {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>{item.tax_rate >= 0 ? (+item.tax_rate + '%') : '-'}</td>);
                          } else if (col.key === 'tax_inclusive_price') {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                              {/* ￥{amountToString(item.tax_inclusive_price)} */}
                              <div style={{ display: 'flex', justifyContent: 'center' }}>{item.tax_inclusive_price === '-' ? '' : <>{amountToString(item.tax_inclusive_price)} / {item.sale_unit}</>}{this.renderDetail(item.surcharge_desc)}</div>
                              {(item.base_factor > 1) && <div >{amountToString(item.tax_inclusive_base_price)} / {item.base_unit}</div>}
                            </td>);
                          } else if ((col.key === 'offer_number')) {
                            return (
                              <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                <div> x{+item.offer_number}</div>
                                {/* <div>{this.renderNumberPopover(item)}</div> */}
                              </td>
                              // <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>x{+item.sale_number}</td>
                            );
                          }
                          else if ((col.key === 'offer_price')) {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>{amountToString(item.offer_price)}</td>);
                          }
                          else if ((col.key === 'receive_base_number')) {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                              {item.base_factor > 1 ? <div>{+(item.receive_base_number / item.base_factor)?.toFixed?.(3)}{item.sale_unit}</div> : null}
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{
                                order_status === 5 ?
                                  <InputNumber precision={3} min={0} defaultValue={item.receive_base_number} onChange={(e) => this.onBlurReceiveNumber(e, item)} controls={false} /> :
                                  <div>{item.base_factor > 1 ? +item.receive_base_number : +(item.receive_base_number / item.base_factor)?.toFixed?.(3)}</div>}
                                {item.base_factor > 1 ? item.base_unit : item.sale_unit}
                              </div>
                            </td>);
                          }
                          // { key: 'offer_price', name: '报价单价', align: 'center' },
                          // { key: 'offer_number', name: '报价数量', align: 'center' },
                          // else if ((col.key === 'subtotal')) {
                          //   // ￥{amountToString(+item.tax_inclusive_real_price)}
                          //   return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>{amountToString(+item.tax_inclusive_real_price)}</td>);
                          // }
                          else {
                            return null;
                          }
                        })
                      }
                      {/* ￥{amountToString(+orderInfo.tax_inclusive_real_price)} */}
                      {index === 0 ? (<td key={index} rowSpan={saleList.length} style={{ textAlign: 'center', fontWeight: '600', borderLeft: '1px solid #e9e9e9' }}>{amountToString(+orderInfo.tax_inclusive_real_price)}</td>) : null}
                    </tr>
                  );
                })
              }
            </tbody>
            <tfoot >
              <tr>
                <td colSpan={1} style={{ textAlign: 'center', fontWeight: '400', padding: 10 }}>商品总计：{amountToString(+tax_inclusive_real_price)}</td>
                <td colSpan={2} style={{ textAlign: 'center', fontWeight: '400', padding: 10 }}>费用：{+orderInfo.orderStatus === 10 ? <span style={{ color: '#D60505' }}>等待报价</span> : <span> <span>{amountToString(otherCost)}</span>{otherCost !== 0 ? <Button type='link' onClick={this.showDetail} style={{ paddingLeft: '10px' }}>明细</Button> : null}</span>}</td>
                <td colSpan={3} style={{ textAlign: 'center', fontWeight: '400', padding: 10 }}>订单总金额：<span style={{ color: '#D60505' }}>{amountToString(totalPrice)}</span></td>
              </tr>
            </tfoot>
          </table>
          {+orderInfo.orderStatus === 20 ? <Row style={{ paddingTop: 20 }}><Col span={4} offset={20} style={{ textAlign: 'right' }}><Button type='primary' onClick={this.createPlanOrder}>创建采购单</Button></Col></Row> : null}
        </div>

        {/* {
          (+orderInfo?.is_report) === 0 ? '' : <>
            <div className='order-quality-container'>
              <div className='order-quality-item'>
                <div className='order-quality-item-top'>
                  <div className='order-quality-item-top-left'>关口质检记录</div>
                </div>
                {
                  (orderInfo?.port_quality_report || [])?.length ?
                    <Table
                      className='order-quality-container-table'
                      dataSource={orderInfo?.port_quality_report || []}
                      rowKey='id' columns={this.port_quality_report_columns}
                      pagination={false}
                      style={{ marginBottom: '20px' }}
                    /> :
                    <div className='c'>暂未提交质检记录</div>
                }
              </div>
            </div>
            <div className='order-quality-container'>
              <div className='order-quality-item'>
                <div className='order-quality-item-top'>
                  <div className='order-quality-item-top-left'>大仓质检反馈</div>
                  <Button type='primary' onClick={this.createWarehouseQualityReport}>创建质检反馈</Button>
                </div>
                {
                  (orderInfo?.warehouse_quality_report || [])?.length ?
                    <Table
                      className='order-quality-container-table'
                      dataSource={orderInfo?.warehouse_quality_report || []}
                      rowKey='id' columns={this.warehouse_quality_report_columns}
                      pagination={false}
                      style={{ marginBottom: '20px' }}
                    /> :
                    <>
                      <div className='c'>暂未提交质检反馈</div>
                    </>
                }
              </div>
            </div>
          </>
        } */}

        <Modal open={this.state.modalVisible} cancelText="取消" okText="确定" onOk={() => { this.handleOk(); }} onCancel={() => { this.handleCancel(); }}>{'是否' + this.state.modalContent + '?'}</Modal>
        {detailVisible ? <DetailModal modalCancel={this.detailCancel} costInfo={costInfo} tax_inclusive_real_price={tax_inclusive_real_price}></DetailModal> : null}
      </div>
    );
  }
}
export default PlanOrderDetail;